import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import {
    Box,
    Flex,
    Copy,
    Dropdown,
    themeColor,
    Selector,
    Icon,
} from '@elparking/components'
import { injectIntl, FormattedMessage } from 'react-intl'
import messages from '../messages'

const Picker = styled(Selector)`
    border: none;
    background-color: transparent;
    min-width: 2em;
    text-align: center;
    color: ${themeColor('main')};
    box-shadow: none;
`

const AgeSelector = ({ intl, value, onChange, error }) => {
    const ageOptions = [
        { value: '18', label: intl.formatMessage(messages.ageSelector1) },
        { value: '19', label: intl.formatMessage(messages.ageSelector2) },
        { value: '20', label: intl.formatMessage(messages.ageSelector3) },
        { value: '21', label: intl.formatMessage(messages.ageSelector4) },
        { value: '22', label: intl.formatMessage(messages.ageSelector5) },
        { value: '23', label: intl.formatMessage(messages.ageSelector6) },
        { value: '24', label: intl.formatMessage(messages.ageSelector7) },
        { value: '25', label: intl.formatMessage(messages.ageSelector8) },
        { value: '26', label: intl.formatMessage(messages.ageSelector9) },
        { value: '27', label: intl.formatMessage(messages.ageSelector10) },
        { value: '28', label: intl.formatMessage(messages.ageSelector11) },
        { value: '76', label: intl.formatMessage(messages.ageSelector12) },
    ]

    return (
        <Box width='100%'>
            <Flex width='100%' alignItems='center' justifyContent='center'>
                <Copy fontWeight='book' fontSize='xSmall' padding='0'>
                    <FormattedMessage defaultMessage='Tengo' />
                </Copy>
                <Dropdown
                  dataTest='age-picker'
                  renderPlaceholder={() => (
                      <Copy
                        padding='0'
                        fontSize='xSmall'
                        color='main'
                        fontWeight='book'
                        >
                          <FormattedMessage defaultMessage='Seleccione una edad' />
                      </Copy>
                    )}
                  renderSelected={({ label }) => (
                      <Copy
                        padding='0'
                        fontSize='xSmall'
                        color='darkMain60'
                        fontWeight='book'
                        >
                          {label}
                      </Copy>
                    )}
                  focusOnClick={false}
                  selectorElement={Picker}
                  options={ageOptions}
                  onChange={onChange}
                  value={`${value}`}
                  defaultValue={undefined}
                  onlyDesktop
                  iconPlaceholderElement={() => (
                      <Icon type='arrow-down' color='main' />
                    )}
                  height='16px'
                  lineHeight='26px'
                />
            </Flex>
            {error && (
                <Copy padding='0' fontColor='error' fontWeight='regular'>
                    <FormattedMessage defaultMessage='Es obligatorio' />
                </Copy>
            )}
        </Box>
    )
}

AgeSelector.propTypes = {
    intl: PropTypes.object,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func,
    error: PropTypes.bool,
}

export default injectIntl(AgeSelector)
